// Växlar visningen av minicart (öppna/stäng)
export function toggleMiniCart() {
    const miniCartWrapper = document.querySelector('#mini-cart-dropdown').parentElement

    if (document.body.classList.contains('mini-cart-open')) {
        miniCartWrapper.classList.remove('active')
        document.body.classList.remove('mini-cart-open')
    } else {
        miniCartWrapper.classList.add('active')
        document.body.classList.add('mini-cart-open')
    }
}

document.addEventListener('click', function (e) {
    if (e.target.closest('.cart-toggle-btn')) {
        toggleMiniCart()
    }
})

function lwWcAjaxUrl(endpoint) {
    const tpl = window.wc_add_to_cart_params?.wc_ajax_url || '/?wc-ajax=%%endpoint%%'
    return tpl.replace('%%endpoint%%', endpoint)
}

jQuery(function ($) {
    function refreshMiniCart() {
        $.ajax({
            url: lwWcAjaxUrl('get_refreshed_fragments'),
            type: 'POST',
            beforeSend: function () {
                $(document.body).trigger('wc_fragment_refresh')
            },
            success: function (data) {
                if (!data.fragments) return

                $.each(data.fragments, function (selector, html) {
                    $(selector).html(html)
                })

                if (data.fragments.total_count > 0) {
                    $('.checkout-button').removeClass('disabled')
                } else {
                    $('.checkout-button').addClass('disabled')
                }

                $(document.body).trigger('wc_fragments_refreshed', [data.fragments])
                $(document.body).trigger('wc_fragments_loaded', [data.fragments])
                $(document.body).trigger('cart_totals_refreshed')
            },
            error: function () {
                $(document.body).trigger('wc_fragments_ajax_error')
            },
        })
    }

    $(document).on(
        'click',
        '.single_add_to_cart_button, .product_type_simple.add_to_cart_button, .lw-loop-ajax-add-to-cart',
        function (e) {
            e.preventDefault()
            e.stopImmediatePropagation()

            var $form = $(this).closest('form.cart')
            var button = $(this)

            var formData = $form.length ? new FormData($form[0]) : new FormData()

            // Build payload from wrapper + selected variation
            if (!$form.length) {
                var $wrap = button.closest('.lw-loop-add-to-cart')
                if ($wrap.length) {
                    var productId = $wrap.data('product-id')
                    var variationId = $wrap.attr('data-selected-variation-id')
                    var attrsJson = $wrap.attr('data-selected-attrs') || '{}'

                    if (!productId || !variationId) {
                        // no selected variation -> do nothing
                        return
                    }

                    formData.set('product_id', productId)
                    formData.set('variation_id', variationId)
                    formData.set('quantity', '1')

                    // also send add-to-cart (some setups like it)
                    formData.set('add-to-cart', productId)

                    try {
                        var attrs = JSON.parse(attrsJson)
                        Object.keys(attrs || {}).forEach(function (k) {
                            formData.set(k, attrs[k])
                        })
                    } catch (err) {
                        // ignore JSON-fel
                    }
                }
            }

            // Befintlig fallback: om simple saknar add-to-cart/product_id
            if (!formData.get('product_id') && !formData.get('add-to-cart')) {
                var productId =
                    button.val() ||
                    button.data('product_id') ||
                    button.attr('data-product_id') ||
                    $form.find('input[name="add-to-cart"]').val()
                if (productId) {
                    formData.set('add-to-cart', productId)
                }
            }

            button.text(liGlobal.addingToCartText)

            $(document.body).trigger('adding_to_cart', [button, formData])

            $.ajax({
                url: lwWcAjaxUrl('add_to_cart'),
                method: 'POST',
                data: formData,
                contentType: false,
                processData: false,

                success: function (data) {
                    var fragments = data && data.fragments ? data.fragments : null
                    var cartHash = data && data.cart_hash ? data.cart_hash : null

                    $(document.body).trigger('added_to_cart', [fragments, cartHash, button])
                    $(document.body).trigger('wc_cart_button_updated', [button])

                    refreshMiniCart()

                    setTimeout(() => {
                        toggleMiniCart()
                        button.text(liGlobal.addToCartText)
                    }, 500)
                },

                error: function () {
                    $(document.body).trigger('wc_add_to_cart_error', [button])
                    button.text(liGlobal.addToCartText)
                },
            })
        }
    )

    // +/-
    $(document).on('click', '.qty-plus', function () {
        const input = $(this).siblings('.mini-qty')
        const newQty = parseInt(input.val(), 10) + 1
        input.val(newQty).trigger('change')
    })

    $(document).on('click', '.qty-minus', function () {
        const input = $(this).siblings('.mini-qty')
        const newQty = Math.max(1, parseInt(input.val(), 10) - 1)
        input.val(newQty).trigger('change')
    })

    $(document).on('change', '.mini-qty', function () {
        const key = $(this).data('cart-item-key')
        const qty = $(this).val()

        $.ajax({
            url: liGlobal.ajaxUrl,
            method: 'POST',
            data: {
                action: 'lw_update_mini_cart_qty',
                cart_item_key: key,
                quantity: qty,
            },
            beforeSend: function () {
                $(document.body).trigger('update_cart_totals')
            },
            success: function (resp) {
                if (resp && resp.success) {
                    refreshMiniCart()
                    $(document.body).trigger('updated_cart_totals')
                    $(document.body).trigger('cart_totals_refreshed')
                }
            },
        })
    })

    // Cross-sells i mini-carten: byt visat pris när antalsvarianten ändras.
    $(document).on('change', '.lw-minicart-cross-sell-variation', function () {
        const row = $(this).closest('.lw-minicart-cross-sell')
        const priceHtml = $(this).find('option:selected').data('price')
        if (priceHtml) row.find('.lw-cross-sell-price').html(priceHtml)
    })

    // Cross-sells "Lägg till" i mini-carten: lägg i varukorgen och refresha mini-carten
    // (utan att öppna/stänga popupen — den är redan öppen). Variabel produkt → valt
    // variations-ID från select, annars simple-produktens ID; WC:s wc-ajax=add_to_cart
    // accepterar variations-ID direkt som product_id. stopImmediatePropagation så den
    // generella add-to-cart-handlern ovan inte också triggar.
    $(document).on('click', '.lw-minicart-cross-sell-add', function (e) {
        e.preventDefault()
        e.stopImmediatePropagation()

        const btn = $(this)
        if (btn.prop('disabled')) return

        const select = btn.closest('.lw-minicart-cross-sell').find('.lw-minicart-cross-sell-variation')
        const productId = select.length ? select.val() : btn.data('product-id')
        if (!productId) return

        const originalText = btn.text()
        btn.prop('disabled', true)
        if (window.liGlobal?.addingToCartText) btn.text(liGlobal.addingToCartText)

        $.ajax({
            url: lwWcAjaxUrl('add_to_cart'),
            method: 'POST',
            data: { product_id: productId, quantity: 1 },
            success: function (data) {
                const fragments = data && data.fragments ? data.fragments : null
                const cartHash = data && data.cart_hash ? data.cart_hash : null
                $(document.body).trigger('added_to_cart', [fragments, cartHash, btn])
                refreshMiniCart()
            },
            complete: function () {
                btn.prop('disabled', false)
                btn.text(originalText)
            },
        })
    })
})
